module.exports = __webpack_public_path__ + "media/images/photos/17-646776267ffaa64c01de486c60fd5903.jpg";